import { Profile, Benefit, Member } from '@td/membersupport';
import { camelCase, mapKeys } from 'lodash';
import { gql }  from '@apollo/client';
import { get } from 'lodash';
import moment from 'moment';
import {
  parseServerMessage
} from '../rte_errors';
import openReg from './open-reg';

window.openReg = openReg;

const performRteCheck = (params, client) => {
  return client
    .query({
      variables: {
        firstName: params.firstName,
        lastName: params.lastName,
        dob: moment(params.dob).format("YYYY-MM-DD"),
        zipCode: "11111", //not needed.... just a search param that gets logged
        payerCode: params.vendor,
        hpid: params.hpid
      },
      query: gql`
        query ($payerCode: String!, $firstName: String!, $lastName: String!, $dob: ISO8601DateTime!, $zipCode: String!, $hpid: String!){
          rteEligibility(payerCode: $payerCode, demographics: {firstName: $firstName, lastName: $lastName, dob: $dob, zipCode: $zipCode, gender: GENDER_UNKNOWN}, payerFields: {healthPlanId: $hpid}) {
            eligible
            explanation
            gatewayDown
            proceed
            demographics
            primary
            vendor
            group {
              name
              effective
              effectiveStartDate
              effectiveEndDate
              oneAppFlag
              serviceSpecialties {
                name
              }
            }
          }
        }
      `
    })
    .then(result => {
        if(result.data.rteEligibility.eligible){
        const member = mapKeys(result.data.rteEligibility.demographics, (v, k) => camelCase(k))
        const person = Member({
          firstName: member.firstName,
          lastName: member.lastName,
          dob: member.dob,
          city: member.city,
          zipCode: member.zipCode,
          state: member.state,
          street: `${get(member, 'streetOne')} ${get(member, 'streetTwo') || ""}`,
          registered: false,
          canRegister:  true,
          healthPlanIds: [params.hpid],
        });

        const profile = Profile({
          benefits: [ Benefit({
          isActive: get(result, 'data.rteEligibility.group.effective'),
          vendor: params.vendor,
          sponsor: get(result, 'data.rteEligibility.group.name'),
          benefitStatus: true,
          coverageStartDate: get(result, 'data.rteEligibility.group.effectiveStartDate'),
          coverageEndDate: get(result, 'data.rteEligibility.group.effectiveEndDate'),
          healthPlanId: params.hpid,
          classification: member.primary ? 'Primary' : 'Dependent',
          products: (get(result, 'data.rteEligibility.group.serviceSpecialties') || []).map( s => s.name ),
        }) ]});
        return { person, error: undefined, profile };
      }else{
        let error = "Unable to determine eligibility"
        try {
          error = result.data
            .rteEligibility
            .explanation
            .children
            .find( c => c.data === "eligibility" )
            .children
            .find( c => c.type == "note" && c.data)
          if(error.data.includes("RTE Error")){
            error = parseServerMessage(error.data)
          } else {
            error = `Unable to determine eligibility: ${error.data}`;
          }
        } catch (e) {
          error = e;
        }
        return { person: undefined, error: error }
      }
    })
    .catch( err => {
      return { person: undefined, error: err }
    });
}

export default performRteCheck;
